import { Nav, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { User } from "../../models/user";
import * as UserApi from "../../network/user_api";
import "./Navbar.scss";
import { useTranslation } from "react-i18next";
import { useClientSideLocaleChange } from "../hooks/useClientSideLocaleChange";
import { LanguageSwitcher } from "./LanguageSwitcher/LanguageSwitcher";

interface NavBarLoggedInViewProps {
  currentUser: User;
  onLogoutSuccessful: () => void;
}

const NavBarLoggedInView = ({
  currentUser,
  onLogoutSuccessful,
}: NavBarLoggedInViewProps) => {
  async function logout() {
    try {
      await UserApi.logout();
      onLogoutSuccessful();
    } catch (error) {
      alert(error);
      console.error(error);
    }
  }

  const navigate = useNavigate();
  const { t } = useTranslation();
  const localeSetMutation = useClientSideLocaleChange();

  const setLocale = async (key: string) => {
    await localeSetMutation.mutateAsync(key);
  };

  return (
    <div className="navbarText me-2 d-flex align-items-center">
      <Nav className="me-2 d-flex align-items-center">
        <LanguageSwitcher onChange={setLocale} />
      </Nav>
      <Nav>
        <NavDropdown
          id="navbarDopdown"
          title={`${t("common.signedInAs")} ${currentUser.userName}`}
        >
          <NavDropdown.Item as={Link} to="/profile">
            {t("pages.profile")}
          </NavDropdown.Item>
          <NavDropdown.Item
            onClick={() => {
              logout();
              navigate(`/`);
            }}
          >
            {t("common.logout")}
          </NavDropdown.Item>
        </NavDropdown>
      </Nav>
      <OverlayTrigger
        placement={"bottom"}
        overlay={<Tooltip id={`tooltip-bottom`}>{currentUser.xp} XP</Tooltip>}
      >
        <div className="levelBadgeNav">
          <div className="hexagonNav"></div>
          <p className="levelBadgeTextNav">{currentUser.level}</p>
        </div>
      </OverlayTrigger>
    </div>
  );
};

export default NavBarLoggedInView;
